import styles from "./gameConnection.module.scss"

const GameConnection = () => {
  return (
    <div className={styles.connection}>
      <i className="icon no-connection big" />
      Opponent has disconnected. Awaiting reconnect...
    </div>
  );
};

export default GameConnection;
